module.exports = __webpack_public_path__ + "img/btn-chat-img.5139e6e3.png";